export default __webpack_public_path__ + "static/media/mint.a9cc8599.png";